import { useMemo, CSSProperties } from 'react';

import { useSystemColourPreference } from './useSystemColourPreference';
import styles from './Hooks.module.scss';

const { darkThemeModalOverlay } = styles;

export const useModalOverlayStyle = (showOverlay: boolean, zIndex: number) => {
    const shouldUseDarkTheme = useSystemColourPreference();
    const defaultOverlayStyle = useMemo(() => {
        let defaultStyle: CSSProperties = { display: 'flex', zIndex };
        if (!showOverlay || (showOverlay && shouldUseDarkTheme)) {
            const backgroundColor = !showOverlay ? 'transparent' : darkThemeModalOverlay;
            defaultStyle = { ...defaultStyle, backgroundColor };
        }
        return defaultStyle;
    }, [shouldUseDarkTheme, showOverlay, zIndex]);
    return defaultOverlayStyle;
};
